import { idbDelete, idbGetAll, idbPutMany } from '../lib/idb';
import type { OutboxOp, OutboxStore } from './outbox';

/** Outbox persisted in IndexedDB: an op is on disk before addEntry() resolves (M3). */
export class IdbOutboxStore implements OutboxStore {
  all() {
    return idbGetAll<OutboxOp>('outbox');
  }
  put(op: OutboxOp) {
    return idbPutMany('outbox', [op]);
  }
  putMany(ops: OutboxOp[]) {
    return idbPutMany('outbox', ops);
  }
  remove(keys: string[]) {
    return idbDelete('outbox', keys);
  }
}
